import Glide, { Controls, Autoplay, Swipe, Keyboard } from '@glidejs/glide/dist/glide.modular.esm'

declare global {
  interface Window {
    isAutoscrollEnabled: boolean
  }
}

const AUTOPLAY_PERIOD = 8000
const AUTOPLAY_TRIGGER_EVENTS = ['mousedown', 'mousemove', 'scroll', 'touchstart']
const TABBABLE_SELECTORS = 'a, button, input, select, textarea, [tabindex]'

const setControlsHidden = ($sliderContainer: HTMLElement, hidden: boolean) => {
  const $controls = $sliderContainer.querySelector<HTMLElement>('[data-glide-el="controls"]')
  const $controlsNav = $sliderContainer.querySelector<HTMLElement>('[data-glide-el="controls[nav]"]')
  if ($controls) $controls.hidden = hidden
  if ($controlsNav) $controlsNav.hidden = hidden
}

const updateSlideAccessibility = (slide: HTMLElement) => {
  const isActive = slide.classList.contains('glide__slide--active')
  slide.setAttribute('aria-hidden', isActive ? 'false' : 'true')

  slide.querySelectorAll<HTMLElement>(TABBABLE_SELECTORS).forEach((el) => {
    if (isActive) {
      if (el.getAttribute('tabindex') === '-1') el.removeAttribute('tabindex')
    } else {
      el.setAttribute('tabindex', '-1')
    }
  })
}

const updateSlidesAccessibility = ($sliderContainer: HTMLElement) => {
  $sliderContainer.querySelectorAll<HTMLElement>('.glide__slide').forEach(updateSlideAccessibility)
}

const bindAutoplayTriggers = (slider: Glide) => {
  window.isAutoscrollEnabled = false

  const startAutoplay = () => {
    if (window.isAutoscrollEnabled) return
    slider.play(AUTOPLAY_PERIOD)
    window.isAutoscrollEnabled = true
  }

  AUTOPLAY_TRIGGER_EVENTS.forEach((eventName) => {
    window.addEventListener(eventName, startAutoplay, { once: true, passive: true })
  })
}

const initSlider = () => {
  const $sliderContainer = document.querySelector<HTMLDivElement>('[data-glide-container]')
  if (!$sliderContainer) return

  const isSingleSlide = $sliderContainer.querySelectorAll('.glide__slide').length <= 1

  if (isSingleSlide) {
    setControlsHidden($sliderContainer, true)
    $sliderContainer.querySelectorAll<HTMLElement>(TABBABLE_SELECTORS).forEach((el) => el.removeAttribute('tabindex'))
    return
  }

  setControlsHidden($sliderContainer, false)

  const slider = new Glide($sliderContainer, { type: 'carousel', perView: 1 })

  bindAutoplayTriggers(slider)
  $sliderContainer.addEventListener('keydown', () => slider.pause(), { once: true })

  slider.on(['mount.after', 'run.after', 'update'], () => updateSlidesAccessibility($sliderContainer))

  slider.mount({ Controls, Autoplay, Swipe, Keyboard })
}

export default initSlider
